
import icon1 from "../../images/partner/icon1.svg"
import icon2 from "../../images/partner/icon2.png"
import icon3 from "../../images/partner/icon3.svg"
import icon4 from "../../images/partner/icon4.svg"
import icon5 from "../../images/partner/icon5.svg"
import icon6 from "../../images/partner/icon6.svg"


const block_data = [
  {
    icon: icon1,
    title: "Retain and Attract Clients",
    desc: "Delight your existing clients and help them make better business decisions by implementing our most advanced technology tools",
    link: "/signup/",
    but: "Get Started",
  },
  {
    icon: icon2,
    title: "Improve Cash Flow",
    desc: "Provide your clients with the opportunity to scale and be financially independent",
    link: "/signup/",
    but: "Get Started",
  },
  {
    icon: icon3,
    title: "Build Better Relationships",
    desc: "Create more customised and engaging relationships with old and new customers that raise more future business",
    link: "/signup/",
    but: "Get Started",
    btnClassName: "sm:pt-5 pt-0"
  },
  {
    icon: icon4,
    title: "Grow Your Business",
    desc: "Reach new customers and markets with your success story shared through our go-to-market channels",
    link: "/signup/",
    but: "Learn More",
    btnClassName: "sm:pt-5 pt-0"
  },
  {
    icon: icon5,
    title: "Be Fully Supported",
    desc: "Empower your team with knowledge and tools to enable smooth digital adoption for your practice and your clients",
    link: "/signup/",
    but: "Find Out",
    btnClassName: "sm:pt-5 pt-0"
  },
  {
    icon: icon6,
    title: "Additional Business Value",
    desc: "Sync LUCA Plus with your clients' existing billing and AR/AP processes in XERO, MYOB, and QuickBooks to get immediate cost savings and operational efficiencies",
    link: "/ebook/",
    but: "Download Now",
    btnClassName: "sm:pt-5 pt-0"
  },
]


export default block_data
